module.exports = __webpack_public_path__ + "media/images/iconDelete__inactive--dark-c646589aff5c1c5aafb9f279a244faae.png";